// Mock data for Digitometrix Technologies Landing Page

export const heroData = {
  headline: "Scale Your Hotel & Resort Bookings with Performance Marketing",
  subheadline: "Meta & Google Ads Strategies Designed Exclusively for Hospitality Brands.",
  images: [
    "https://images.unsplash.com/photo-1549294413-26f195200c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZXNvcnR8ZW58MHx8fHwxNzcxNDg1NDU2fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbHxlbnwwfHx8fDE3NzE0ODU0NjB8MA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/28443535/pexels-photo-28443535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Performance Marketing",
    description: "Data-driven campaigns that maximize ROI and deliver measurable results for your hospitality business.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Meta Ads Management",
    description: "Strategic Facebook & Instagram advertising to reach travelers actively seeking accommodation.",
    icon: "Facebook"
  },
  {
    id: 3,
    title: "Google Ads Management",
    description: "Capture high-intent bookings through search, display, and hotel ads campaigns.",
    icon: "Search"
  },
  {
    id: 4,
    title: "Social Media Management",
    description: "Build your brand presence and engage potential guests across all social platforms.",
    icon: "Share2"
  },
  {
    id: 5,
    title: "Marketing Strategy",
    description: "Comprehensive growth strategies tailored for your property's unique market position.",
    icon: "Target"
  },
  {
    id: 6,
    title: "Property Marketing Management",
    description: "Complete marketing solutions to showcase your property and drive direct bookings.",
    icon: "Building2"
  },
  {
    id: 7,
    title: "Lead Generation Systems",
    description: "Automated systems that convert website visitors into confirmed bookings.",
    icon: "Users"
  },
  {
    id: 8,
    title: "WhatsApp Marketing Automation",
    description: "Streamlined booking communication through WhatsApp for instant guest engagement.",
    icon: "MessageCircle"
  },
  {
    id: 9,
    title: "AI Automation for Hospitality",
    description: "Cutting-edge AI tools to optimize operations and enhance guest experience.",
    icon: "Bot"
  },
  {
    id: 10,
    title: "Website Design & Development",
    description: "Stunning, conversion-optimized websites that turn visitors into guests.",
    icon: "Globe"
  },
  {
    id: 11,
    title: "Content Creation & Influencer Collaborations",
    description: "Engaging visual content and strategic influencer partnerships that showcase your property and attract quality bookings.",
    icon: "Camera"
  }
];

export const portfolioData = [
  {
    id: 1,
    name: "Ayati Resort",
    location: "Mahabaleshwar",
    image: "https://images.pexels.com/photos/2506988/pexels-photo-2506988.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    services: "Meta Ads, Google Ads, Social Media Management",
    results: {
      bookings: "+180%",
      leads: "500+",
      roi: "3.5x"
    },
    testimonial: "Digitometrix transformed our booking strategy. We saw a 180% increase in direct bookings within 3 months!"
  },
  {
    id: 2,
    name: "Prachitas Green Field Family Resort",
    location: "Karjat",
    image: "https://images.unsplash.com/photo-1610641818989-c2051b5e2cfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxyZXNvcnR8ZW58MHx8fHwxNzcxNDg1NDc3fDA&ixlib=rb-4.1.0&q=85",
    services: "Performance Marketing, Lead Generation",
    results: {
      bookings: "+220%",
      leads: "750+",
      roi: "4.2x"
    },
    testimonial: "Outstanding results! Our family resort is now fully booked on weekends, thanks to their targeted campaigns."
  },
  {
    id: 3,
    name: "Green Acres Inn Resort",
    location: "Wada, Palghar",
    image: "https://images.unsplash.com/photo-1540541338287-41700207dee6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxyZXNvcnR8ZW58MHx8fHwxNzcxNDg1NDc3fDA&ixlib=rb-4.1.0&q=85",
    services: "Google Ads, WhatsApp Marketing",
    results: {
      bookings: "+150%",
      leads: "400+",
      roi: "3.8x"
    },
    testimonial: "The WhatsApp automation system they set up has streamlined our entire booking process."
  },
  {
    id: 4,
    name: "Springfield Villa",
    location: "Alibaug",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHx2aWxsYXxlbnwwfHx8fDE3NzE0ODU0ODF8MA&ixlib=rb-4.1.0&q=85",
    services: "Meta Ads, Website Development",
    results: {
      bookings: "+200%",
      leads: "320+",
      roi: "4.5x"
    },
    testimonial: "From empty weekends to fully booked months ahead. Exceptional service and results!"
  },
  {
    id: 5,
    name: "Mango Tree Villa",
    location: "Virar",
    image: "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHx2aWxsYXxlbnwwfHx8fDE3NzE0ODU0ODF8MA&ixlib=rb-4.1.0&q=85",
    services: "Performance Marketing, AI Automation",
    results: {
      bookings: "+190%",
      leads: "450+",
      roi: "4.0x"
    },
    testimonial: "The AI automation tools have saved us countless hours while increasing bookings significantly."
  }
];

export const founderData = {
  name: "Ghanshyam Lotlikar",
  alias: "Digital Shyaam",
  title: "Performance Marketing Expert",
  company: "Founder – Digitometrix Technologies",
  image: "https://customer-assets.emergentagent.com/job_digitometrix-hotel/artifacts/rtd53m9k_Shyam-Profile.jpg",
  experience: [
    "8+ Years in Digital Marketing",
    "Hospitality Growth Specialist",
    "ROI-Driven Ad Strategist",
    "Helped Multiple Hospitality Brands Scale Bookings",
    "Focus on Performance, Automation & Systems"
  ],
  bio: "With over 8 years of hands-on experience in performance marketing, Ghanshyam has helped dozens of hospitality properties transform their marketing approach. His data-driven strategies and automation systems have generated millions in direct booking revenue for hotels, resorts, and villas across India."
};

export const visionMissionData = {
  vision: {
    title: "Our Vision",
    description: "To become India's most trusted performance marketing partner for hospitality brands, helping properties achieve predictable, scalable, and profitable growth through digital innovation."
  },
  mission: {
    title: "Our Mission",
    description: "To empower hotel, resort, and villa owners with ROI-driven marketing systems, automation tools, and performance strategies that increase direct bookings, reduce dependency on third-party platforms, and maximize revenue potential."
  }
};

export const whyChooseUsData = [
  {
    id: 1,
    title: "Data-Driven Campaign Execution",
    description: "Every decision backed by analytics and performance metrics",
    icon: "BarChart3"
  },
  {
    id: 2,
    title: "Hospitality-Specific Ad Strategies",
    description: "Strategies tailored exclusively for hotels, resorts & villas",
    icon: "Hotel"
  },
  {
    id: 3,
    title: "Transparent ROI Reporting",
    description: "Clear, detailed reports showing exactly where your investment goes",
    icon: "PieChart"
  },
  {
    id: 4,
    title: "Automated Lead Systems",
    description: "Turn-key systems that work 24/7 to generate bookings",
    icon: "Zap"
  },
  {
    id: 5,
    title: "WhatsApp Booking Funnels",
    description: "Direct guest communication for instant booking confirmations",
    icon: "MessageSquare"
  },
  {
    id: 6,
    title: "AI-Enabled Marketing Optimization",
    description: "Cutting-edge AI tools to maximize campaign performance",
    icon: "Cpu"
  },
  {
    id: 7,
    title: "Dedicated Growth Consultation",
    description: "Personalized strategy sessions focused on your property's success",
    icon: "Headphones"
  },
  {
    id: 8,
    title: "8+ Years of Experience",
    description: "Proven track record since 2017 in hospitality marketing",
    icon: "Award"
  }
];

export const contactData = {
  phone: "+91 9867809539",
  email: "hello@digitometrix.in",
  address: "Wing G2 Flat 1112, Sarova, Samata Nagar, Kandivali East, Mumbai – 400101",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.7836!2d72.8547!3d19.2037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDEyJzEzLjMiTiA3MsKwNTEnMTYuOSJF!5e0!3m2!1sen!2sin!4v1234567890"
};

// Mock function to simulate form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted:', formData);
      resolve({ success: true, message: 'Thank you! We will contact you soon.' });
    }, 1000);
  });
};

// Mock function to simulate newsletter subscription
export const subscribeNewsletter = async (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Newsletter subscription:', email);
      resolve({ success: true, message: 'Successfully subscribed!' });
    }, 800);
  });
};
